import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import WatchList, { FAVORITE_PLUS_HOVER, FAVORITE_TYPE_WATCHLIST } from 'components/Favorite';
import { noop } from 'helpers/GlobalHelper';
import { isSeries, isTypeSeries } from 'helpers/ContentHelper';
import { HoverStateToolTip, Overlay, SimplifiedImage } from '../../components';

import Style from '../../styles/Simplified.module.scss';

const Simplified = ({
  badge,
  breakpoint,
  favoritesManager,
  isGrid,
  item,
  itemIndex,
  link: route,
  maxItems,
  onPosterClick,
  overlayProps,
  posterAltText,
  posterImage,
  preventLazyLoad,
  scaleFromLeft,
  scaleFromRight,
  segmentPlaylistButtonAction,
}) => {
  const [isFavorite, setFavorite] = useState(false);
  const { description = '', isSeriesDetailAvailable, seriesType } = item;
  const isCollectionSeries = isTypeSeries(item?.['@type'] ?? '');
  const isVideoSeries = isSeries(seriesType);
  const favoriteData = overlayProps?.favoriteData ?? {};
  const favorites = favoritesManager?.favorites;
  const isOnlyWatchList = isVideoSeries || isSeriesDetailAvailable === false;
  const name = isVideoSeries && !isCollectionSeries ? item?.name : null;
  const getCarouselPosterClasses = [];
  useEffect(() => {
    const isFavorite = () => {
      let results = [];
      if (!favoritesManager || !favoritesManager.favorites) return false;
      favoriteData?.favoritableItems?.forEach(item => {
        const matches = favoritesManager.favorites.filter(
          favorite => item.id === favorite.favoriteID,
        );
        results = [...matches, ...results];
      });
      return results.length > 0;
    };
    setFavorite(isFavorite());
  }, [favoriteData?.favoritableItems, favoritesManager]);

  if (itemIndex === 0 || scaleFromLeft) {
    getCarouselPosterClasses.push(Style.carouselPosterFirst);
  } else if (itemIndex === maxItems - 1 || scaleFromRight) {
    getCarouselPosterClasses.push(Style.carouselPosterEnd);
    if (item.id === 'seeMore') {
      getCarouselPosterClasses.push(Style.invisible);
    }
  } else {
    getCarouselPosterClasses.push(Style.carouselPoster);
  }

  if (isGrid) {
    getCarouselPosterClasses.push(Style.gridPoster);
  }

  const posterImageProps = {
    badge: overlayProps.isPersonality ? overlayProps.badge : badge,
    breakpoint,
    image: posterImage,
    isGrid,
    item,
    onPosterClick,
    posterAltText,
    preventLazyLoad,
    route,
    theme: Style,
  };

  return (
    <div key={itemIndex} className={classNames(getCarouselPosterClasses)}>
      <SimplifiedImage {...posterImageProps} />
      {favoritesManager && (
        <Overlay theme={Style}>
          <span className={Style.watchList}>
            <span className={Style.watchListButtonContainer}>
              <WatchList
                type={FAVORITE_TYPE_WATCHLIST}
                stopNavigationOnClick
                manager={favoritesManager}
                iconType={FAVORITE_PLUS_HOVER}
                setFavorite={setFavorite}
                favorites={favorites}
                data={{ ...favoriteData, titleText: name, subtitleText: description }}
                segmentPlaylistButtonAction={segmentPlaylistButtonAction}
              />
            </span>
            <HoverStateToolTip
              theme={Style}
              isFavorited={isFavorite}
              isRightJustified={isOnlyWatchList}
            />
          </span>
        </Overlay>
      )}
    </div>
  );
};

export default Simplified;

Simplified.defaultProps = {
  badge: null,
  breakpoint: null,
  favoritesManager: null,
  isGrid: false,
  item: {},
  itemIndex: 0,
  link: null,
  maxItems: 0,
  onPosterClick: noop,
  overlayProps: {},
  posterAltText: null,
  posterImage: null,
  preventLazyLoad: false,
  scaleFromLeft: false,
  scaleFromRight: false,
  segmentPlaylistButtonAction: noop,
};

Simplified.propTypes = {
  badge: PropTypes.string,
  breakpoint: PropTypes.string,
  favoritesManager: PropTypes.shape({}),
  isGrid: PropTypes.bool,
  item: PropTypes.shape({}),
  itemIndex: PropTypes.number,
  link: PropTypes.string,
  maxItems: PropTypes.number,
  onPosterClick: PropTypes.func,
  overlayProps: PropTypes.shape({}),
  posterAltText: PropTypes.string,
  posterImage: PropTypes.string,
  preventLazyLoad: PropTypes.bool,
  scaleFromLeft: PropTypes.bool,
  scaleFromRight: PropTypes.bool,
  segmentPlaylistButtonAction: PropTypes.func,
};
